import axios from 'axios'
import {services, getHeader} from '@/assets/js/config.js'

export default () => {
	
	const downloadFromAttachmnetService = (attc_id, file_name="Download") => {
		axios.get(services.attachment + 'attachments/' + attc_id + '/download',{
			headers: getHeader(),
			responseType: 'blob'
		})
		.then(response => {
			_gHlp.createDownloadFileLink(response.data, file_name)
		})
		.catch(e => {
			_gNotif.errorFunction(e)
		});
	}


	const getContentUrl = (imageUrl) =>{
		let b64Result = null

		const getImageAsBase64 = (url, callback) => {
			var img = new Image();
			img.crossOrigin = 'Anonymous'; // Enable CORS
	
			img.onload = function () {
					var canvas = document.createElement('canvas');
					canvas.width = this.width;
					canvas.height = this.height;
	
					var ctx = canvas.getContext('2d');
					ctx.drawImage(this, 0, 0);
	
					var base64String = canvas.toDataURL('image/png'); // Change format if needed
					callback(base64String);
			};
	
			img.onerror = function () {
					callback(null);
			};
	
			img.src = url;
		}
	
		getImageAsBase64(imageUrl, function (base64String) {
			b64Result = null;
			if (base64String) {
					b64Result = base64String
			} 
		});

		return b64Result;
	}
	const getBankLogo = (bank_id) => {
		switch (bank_id) {
			case 1 :{ 
				//CIMB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/cimb.png';
				break;
			}	
			case 2 :{ 
				//ALB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/alb.png';
				break;
			}	
			case 3 :{ 
				//RHB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/rhb.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/rhb+2.png';
				break;
			}	
			case 4 :{ 
				//AMB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/amb.png';
				break;
			}	
			case 5 :{ 
				//PBB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/pbb.png';
				break;
			}	
			case 7 :{ 
				//HSBC
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/hsbc.png';
				break;
			}	
			case 8 :{ 
				//SCB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/scb.png';
				break;
			}	
			case 10:{ 
				// BI
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/bi.png';
				break;
			}	
			case 11:{ 
				// UOB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/uob.png';
				break;
			}	
			case 12:{ 
				// MBB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/mbb.png';
				break;
			}	
			case 13:{ 
				// BR
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/br.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/b.raykat.png';
				break;
			}	
			case 14:{ 
				// MBSB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/mbsb.png';
				break;
			}	
			case 15:{ 
				// Koperasi
				return '#'
				break;
			}	
			case 17:{ 
				// Houzkey
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/citibank.png';
				break;
			}	
			case 18:{ 
				// OCBC
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/ocbc.png';
				break;
			}	
			case 21:{ 
				// HLB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/hlb.png';
				break;
			}	
			case 23:{ 
				// AIA
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/aia.png';
				break;
			}	
			case 24:{ 
				// BSN
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/bsn.png';
				break;
			}	
			case 26:{ 
				// ABM
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/abm.png';
				break;
			}	
			case 27:{ 
				// AEON
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/aeon.png';
				break;
			}	
			case 28:{ 
				// Agro
				return '#'
				break;
			}	
			case 29:{ 
				// Al Rajhi
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/al+rajhi.png';
				break;
			}	
			case 30:{ 
				// Kuwait
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/kuwait.png';
				break;
			}	
			case 31:{ 
				// OTB
				return '#'
				break;
			}	
			case 32:{ 
				// LPPSA
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/lppsa.png';
				break;
			}	
			case 33:{ 
				// BMMB
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/bmmb.png';
				break;
			}	
			case 34:{ 
				// AXIATA
				return '#'
				break;
			}	
			case 35:{ 
				// KCP
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/kcp.png';
				break;
			}	
			case 36:{ 
				// BOC
				return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/boc.png';
				break;
			}	
			case 37:{ 
				// CASH_BUY
				return '#'
				break;
			}	
			default:
				return '#'
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/affin-islamic.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/aia-bk.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/alliance-islamic.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/ambank-islamic.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/cimb-Islamic.png';

				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/debt-consolidate.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/hong-leong-islamic.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/imoney-malaysia.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/master-list-title.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/maybank-islamic.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/ocbc-al-amin.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/public-islamic.png';
				// return 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/banks/standard-chartered-saadiq.png';
				break;
		}
	}

	return {
		downloadFromAttachmnetService,
		getContentUrl,
		getBankLogo
	}
}